import React, { memo } from 'react';
import { rem } from 'design-system';
import { StyleSheet } from 'react-native';
import AlertViewNew from 'design-system/AlertViewNew';
import useFailedPayment from 'features/premium/hooks/useFailedPayment';
import Section from '../Section';
const SubscriptionPaymentFailed = ({ style, withMarginBottom, noMarginBottom, withFrame = true, }) => {
    const { changingPaymentMethod, onPressUpdatePayment, titleText, subtitleText, } = useFailedPayment();
    return (<Section withFrame={withFrame} style={[
            styles.section,
            withMarginBottom && styles.withMarginBottom,
            noMarginBottom && styles.noMarginBottom,
            style,
        ]}>
      <AlertViewNew onPress={changingPaymentMethod ? undefined : onPressUpdatePayment} action={'Update payment method'} title={titleText} subTitle={subtitleText} noMargin={!withFrame} testID="subscriptionFailedCard"/>
    </Section>);
};
const styles = StyleSheet.create({
    section: {
        marginTop: rem(8),
        marginBottom: rem(8),
    },
    withMarginBottom: {
        marginBottom: rem(16),
    },
    noMarginBottom: {
        marginBottom: rem(0),
    },
});
export default memo(SubscriptionPaymentFailed);
